import { addEditDataAPI } from 'services/CRUDServices'

export async function gatewayPayment(payment, url) {
  const res = await addEditDataAPI(url, 'post', payment)

  const link = res.data.response
  window.open(
    `${process.env.REACT_APP_PUBLIC_URL}/web/payments/payment-links/${link}`
  )
}
